import { sortByDate } from "@/functions/sortByDate";
import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "../../.sourceflow/blogs.json";

export const useBlogs = ({ limit = null } = {}) => {
  const collection = sortByDate(useSourceFlowCollection(data), "publish_date");

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useBlogs;
